import {defineMessages} from 'react-intl';

export default defineMessages({
	color: {
		id: 'productLineItem.color',
		defaultMessage: 'Color',
	},
	size: {
		id: 'productLineItem.size',
		defaultMessage: 'Size',
	}
});